export default __webpack_public_path__ + "static/media/junctionx.0d7485ad.png";